module.exports = __webpack_public_path__ + "wap/static/img/tagNoResult@3x.c28a208.png";